import { jsmWorkItemIncidentEmbedRoute } from '@jira/router-routes__jsm-work-item-incident-routes/src/jsmWorkItemIncidentEmbedRoute.tsx';
import { jsmWorkItemIncidentEntryPoint } from '@jira/spa-apps__jsm-work-item-incident/src/jsmWorkItemIncidentEntryPoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const jsmWorkItemIncidentPageEntrypoint = createPageEntryPoint({
	main: jsmWorkItemIncidentEntryPoint,
});

export const jsmWorkItemIncidentEmbedRouteEntry: Route = createEntry(
	jsmWorkItemIncidentEmbedRoute,
	() => ({
		group: 'servicedesk',

		layout: chromelessLayout,

		resources: [],

		entryPoint: () =>
			fg('jsm_aniv_incidents') ? jsmWorkItemIncidentPageEntrypoint : notFoundPageEntrypoint,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
